import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

// Custom components to ensure <mark> and other elements render cleanly with purple text and NO background box
const ExportMarkdownComponents = {
  mark: ({ node, children, ...props }) => (
    <span
      style={{
        color: "#3D2B90",
        fontWeight: "bold",
        fontFamily: "inherit",
        backgroundColor: "transparent",
        border: "none",
        padding: "0",
      }}
      {...props}
    >
      <font color="#3D2B90">
        <b>{children}</b>
      </font>
    </span>
  ),
};

// Renders markdown to HTML with the SAME renderer/plugins as the on-screen panels,
// so exported PDFs and Word docs show formatted headings/lists/bold/purple text without background boxes or raw tags.
export const markdownToHtml = (markdown) => {
  const markup = renderToStaticMarkup(
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={ExportMarkdownComponents}
    >
      {markdown || ""}
    </ReactMarkdown>
  );
  return markup.replace(
    /<mark[^>]*>(.*?)<\/mark>/gi,
    '<span style="color:#3D2B90;font-weight:bold;"><font color="#3D2B90"><b>$1</b></font></span>'
  );
};

// Inline stylesheet embedded into each offscreen PDF container so html2canvas
// captures the formatted look regardless of app CSS.
export const MD_PDF_STYLE = `<style>
  h1{font-size:1.8em;font-weight:700;margin:0 0 0.4em;}
  h2{font-size:1.45em;font-weight:700;margin:1em 0 0.35em;}
  h3{font-size:1.2em;font-weight:700;margin:0.9em 0 0.3em;}
  h4,h5,h6{font-size:1.05em;font-weight:700;margin:0.8em 0 0.25em;}
  p{margin:0 0 0.5em;}
  ul,ol{margin:0 0 0.6em;padding-left:1.5em;}
  li{margin:0 0 0.15em;}
  blockquote{border-left:3px solid #c7bfe4;margin:0 0 0.6em;padding-left:10px;color:#555;}
  table{border-collapse:collapse;margin:0 0 0.7em;width:auto;}
  th,td{border:1px solid #ccc;padding:4px 8px;text-align:left;}
  th{background:#f3f1f9;font-weight:700;}
  hr{border:none;border-top:1px solid #ddd;margin:0.9em 0;}
  code{background:#f3f1f9;border-radius:3px;padding:1px 4px;}
  pre{background:#f3f1f9;border-radius:6px;padding:8px 10px;margin:0 0 0.7em;white-space:pre-wrap;overflow-wrap:anywhere;}
  pre code{background:none;padding:0;}
  a{color:#3d2b90;text-decoration:none;}
  img{max-width:100%;}
  mark{background:none!important;background-color:transparent!important;color:#3D2B90!important;font-weight:700!important;border:none!important;padding:0!important;margin:0!important;}
</style>`;
